import React from 'react';
import ForgetPasswordForm from 'components/authentication/ForgetPasswordForm';
import AuthCardLayout from 'layouts/AuthCardLayout';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import paths from 'routes/paths';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ForgetPassword = () =>
{
  return (
    <AuthCardLayout>
      <h4 className="mb-0"> Forgot your password?</h4>
      <p className="mb-0">Enter your email and we'll send you a reset link.</p>
      <ForgetPasswordForm />
      <Button
        as={Link}
        color="primary"
        size="sm"
        className="position-absolute bottom-0 end-0 m-5 d-none d-md-block"
        to={paths.login}
      >
        <FontAwesomeIcon
          icon="chevron-left"
          transform="shrink-4 down-1"
          className="me-1"
        />
        Return to login
      </Button>
    </AuthCardLayout>
  );
};

export default ForgetPassword;
